import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  IGetUpdateAuthorizationBody,
  IGetUpdateAuthorizationResponse,
  ISetUpdateAuthorizationBody,
  ISetUpdateAuthorizationResponse,
} from '../models/updateAuthorization.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdateAuthorizationService {
  private apiUrl = environment.updateAuthorization;

  constructor(private http: HttpClient) {}

  getUpdateAuthorization(
    data: IGetUpdateAuthorizationBody
  ): Observable<IGetUpdateAuthorizationResponse> {
    return this.http.post<IGetUpdateAuthorizationResponse>(this.apiUrl, data);
  }

  setUpdateAuthorization(
    data: ISetUpdateAuthorizationBody
  ): Observable<ISetUpdateAuthorizationResponse> {
    return this.http.post<ISetUpdateAuthorizationResponse>(this.apiUrl, data);
  }
}
